import React from "react";

function ApiPricesIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 -960 960 960"
    >
      <path d="M200-280v-280h80v280h-80zm240 0v-280h80v280h-80zM80-120v-80h800v80H80zm600-160v-280h80v280h-80zM80-640v-80l400-200 400 200v80H80zm178-80h444-444zm0 0h444L480-830 258-720z"></path>
    </svg>
  );
}

export default ApiPricesIcon;
